import { render, staticRenderFns } from "./groupsList.vue?vue&type=template&id=10d7b9bd&scoped=true"
import script from "./groupsList.vue?vue&type=script&lang=js"
export * from "./groupsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d7b9bd",
  null
  
)

export default component.exports